<template>
  <div>
    <b-button @click="browse" type="is-primary" class="mb-3" expanded
      >Import</b-button
    >
    <input
      type="file"
      class="is-hidden"
      ref="file"
      @change="change"
      accept="text/csv,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: File,
  },
  methods: {
    browse() {
      this.$refs.file.click();
    },
    change(e) {
      this.$emit('uploaded', e.target.files[0]);
      this.$refs.file.value = '';
    },
  },
};
</script>
